<template>
  <div class="use-all">
    <el-dialog
      title="留言咨询"
      @close="closeDialog"
      :visible.sync="usedialogVisible"
      width="800px
    "
    >
      <div class="pwshclass">
        <div class="leave-message">
          <p class="pwshclassp">
            如您有任何服务建议或需求，请留下您的信息，我们将尽快联系您！感谢您的留言！
          </p>
          <el-form
            :model="form"
            ref="formRef"
            :rules="rules"
            class="formstyle"
            label-width="90px"
          >
            <el-form-item label="留言类型:" prop="messageType" :required="true">
              <el-select
                class="newslact"
                v-model="form.messageType"
                placeholder="请选择"
              >
                <el-option
                  v-for="option in messageOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细描述:" prop="message" :required="true">
              <el-input
                style="height: 100px;"
                class="newslact"
                type="textarea"
                placeholder="请输入详细描述"
                v-model="form.message"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号码:" prop="phone" :required="true">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号"
                class="newslact"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱:" prop="mailbox" :required="true">
              <el-input
                class="newslact"
                v-model="form.mailbox"
                placeholder="请输入邮箱号"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="qr-code">
          <p>扫码添加企业微信号</p>
          <img src="@/assets/img/gongzhonghao.png" alt="QR Code 1" />
          <!-- <img src="您的二维码图片链接" alt="微信公众号二维码"> -->
        </div>
      </div>
      <span class="newfooter">
        <el-button type="primary" style="width: 180px;" @click="handleSubmit"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {
        messageType: "",
        message: "",
        phone: "",
        mailbox: "",
      },
      rules: {
        messageType: [
          { required: true, message: "请选择留言类型", trigger: "blur" },
        ],
        message: [
          { required: true, message: "请输入详细描述", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
        mailbox: [
          { required: true, message: "请输入邮箱号", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9._%+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
      },
      messageOptions: [
        { value: "合作咨询", label: "合作咨询" },
        { value: "反馈意见", label: "反馈意见" },

        { value: "新增需求", label: "新增需求" },
      ], // 这里存储从接口获取并处理后的选项数组
      activeIndex: "1",
      navBackground: "#fff",
    };
  },
  props: {
    selectIndex: {
      type: String,
      default: "0",
    },
  },
  computed: {
    ...mapGetters(["usedialogVisible"]), // 确保映射 isLogin getter
  },

  mounted() {
    this.activeIndex = this.selectIndex;
    window.onscroll = () => {
      if (document.documentElement.scrollTop > 390) {
        this.navBackground = "#fff";
      } else {
        this.navBackground = "#fff";
      }
    };
  },
  methods: {
    closeDialog() {
      // 提交 mutation 来关闭弹框
      this.$store.commit("setusedialogVisible", false);
    },
    handleCancel() {
      //   this.usedialogVisible = false;
    },
    // handleClose() {
    //   this.usedialogVisible = false;
    // },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            // 假设 token 存储在 localStorage 中

            // 请求数据

            // 发起请求
            const token = localStorage.getItem("token");
            let config = {};
            if (token) {
              config = {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              };
            }
            const response = await this.axios.post(
              "https://www.hittik.com/zntop/top/addMessage",
              this.form,
              config
            );

            if (response.data.code === 200) {
              this.$message({
                message: "提交成功",
                type: "success", // 可选类型：success、warning、info、error
              });
              (this.form = {
                messageType: "",
                message: "",
                phone: "",
                mailbox: "",
              }),
                this.closeDialog();
            } else {
              this.$message({
                message: response.data.msg,
                type: "error", // 可选类型：success、warning、info、error
              });
            }

            // 处理响应
            console.log(response.data);
          } catch (error) {
            // 处理错误
            console.error("请求失败:", error);
          }
          // 在这里发送 AJAX 请求或执行其他逻辑
        } else {
          // alert("表单验证失败");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.newslact {
  width: 300px;
}
.navbar_wrap {
  width: 100%;
  height: 70px;
  background: #0e206c;

  // backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 81px;
      margin-right: -101px;
      img {
        width: 160px;
        cursor: pointer;
      }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: right;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        &:hover {
          font-weight: 600;
          background: transparent !important;
        }
      }
      .right_phone {
        &:hover {
          color: #ccc;
        }
        transition: all 0.5s;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
        span {
          margin-left: 0.5rem;
        }
        margin-left: 2.5rem;
        color: #fff;
      }
    }
  }
}
.pwshclass {
  width: 100%;
  height: 450px;
  display: flex;
  justify-content: space-between;
}

.right_menu {
  display: flex;
  align-items: center;
  margin-left: 800px;
  justify-content: right;
  margin-top: 10px;
  img {
    width: 30px;
    height: 30px;
  }
}
.leave-message {
  display: flex;
  flex-direction: column;
  width: 409px;
}
.pwshclassp {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.01px;
  color: #333333;
  padding: 10px;
}

.qr-code {
  display: flex;
  padding-top: 100px;
  flex-direction: column;
  width: 40%;
  align-items: center;

  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #333333;
}
.formstyle {
  padding: 10px;
}

.qr-code img {
  width: 135px;
  height: 135px;
}
.custom-dialog .el-dialog__header {
  border-top: 1px solid #ccc; /* 灰色线 */
}

.dialog-header-line {
  border-top: 1px solid #ccc; /* 灰色线 */
  margin: -1px; /* 调整边距 */
}
::v-deep .el-form-item__label {
  text-align: left;
}
::v-deep .el-textarea__inner {
  height: 100%;
}
.newfooter {
  display: flex;
  margin-top: -57px;
  margin-left: 150px;
}
</style>
